import Initial from '../../../components/Initial'
import Panel, { PanelBody } from '../../../components/Panel'
import useInitial from '../useInitial'
import Control from './Controls'
import Table from './Table'

export default function Providers() {
    const { state } = useInitial()
    return (
        <Initial pageState={state}>
            <Panel>
                <PanelBody>
                    <Control />
                    <Table />
                </PanelBody>
            </Panel>
        </Initial>
    )
}
